import axios from "axios";
import { apiFetch } from "./apiFetch";
import { handleApiError, getErrorMessage } from "./errorHandler";

export const getChats = async (limit = 20, before = null, search = "") => {
  try {
    let url = `/messenger/chats?limit=${limit}`;

    if (before) {
      url += `&before=${encodeURIComponent(before)}`;
    }

    if (search?.trim()) {
      url += `&search=${encodeURIComponent(search.trim())}`;
    }

    const response = await apiFetch(url);

    if (!response.ok) {
      const errorMsg = getErrorMessage(response);
      console.error("[getChats] Erro:", errorMsg);
      throw new Error(errorMsg);
    }

    const data = await response.json();

    return {
      chats: (data.chats || []).map((chat) => ({
        ...chat,
        LOGO: chat.LOGO || null,
      })),
      hasMore: data.hasMore,
    };
  } catch (err) {
    const handled = handleApiError(err, "getChats");
    return { chats: [], hasMore: false, error: handled.message };
  }
};



export const editarChat = async ({
  token,
  chatstp,
  nomeGrupo,
  fotogrupo
}) => {
  try {
    const body = {
      chatstp,
      nomeGrupo
    };

    if (fotogrupo) {
      body.fotogrupo = fotogrupo;
    }

    const response = await axios.patch(
      `${process.env.REACT_APP_API_URL}/messenger/chats`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      throw new Error("Sessão expirada. Faça login novamente.");
    }
    throw error;
  }
};